import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import './styles.css';
import { applyTheme } from './lib/theme.js';

applyTheme();

const el = document.getElementById('root');
if (!el) throw new Error('root element missing');

createRoot(el).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
